jQuery(document).ready(function($) {
    var DropdownCheckList = {
        init: function() {
            this.bindEvents();
        },

        bindEvents: function() {
            $('.xth-select-multiple .xth-anchor').click(this.toggleDropdownVisibility);
            $('.xth-dropdown-check-list ul.xth-items li').click(this.toggleCheckbox);
            $(document).click(this.handleDocumentClick);
            $('.xth-dropdown-check-list ul.xth-items li input[type="checkbox"]').click(function(e) {
                e.stopPropagation();
            });
        },

        toggleDropdownVisibility: function(e) {
            e.stopPropagation();
            var $parentDropdown = $(this).parents('.xth-select-multiple');
            $('.xth-select-multiple').not($parentDropdown).removeClass('visible');
            $parentDropdown.toggleClass('visible');
        },

        toggleCheckbox: function(e) {
            e.stopPropagation();
            var $checkbox = $(this).find('input[type="checkbox"]');
            $checkbox.prop('checked', !$checkbox.prop('checked'));
            $checkbox.change();
        },

        handleDocumentClick: function(e) {
            if (!$(e.target).closest('.xth-select-multiple').length) {
                $('.xth-select-multiple').removeClass('visible');
            }
            if ($(e.target).is('.sort-trigger') || $(e.target).closest('.sort-trigger').length) {
                $('.xth-select-multiple').removeClass('visible');
            }
        }
    };

    DropdownCheckList.init();
});
